'use client';
import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import mn from '@/locales/mn.json';
import ko from '@/locales/ko.json';

export type Language = 'mn' | 'ko';

type Translations = typeof mn;

const locales: Record<Language, Translations> = { mn, ko };

interface LanguageContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextValue>({
  language: 'mn',
  setLanguage: () => {},
  t: mn,
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>('mn');

  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang);
  }, []);

  return (
    <LanguageContext.Provider data-component-id="src/context/LanguageContext.tsx:32:4" data-component-path="src/context/LanguageContext.tsx" data-component-line="32" data-component-end-line="34" data-component-file="LanguageContext.tsx" data-component-name="LanguageContext.Provider" data-component-content="%7B%22elementName%22%3A%22LanguageContext.Provider%22%7D" value={{ language, setLanguage, t: locales[language] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
